import React from 'react';
import SurveyDownloadModal from './SurveyDownloadModal';
import {INSTANCE_FILTERS} from '../../constants';

const formats = {
    csv: {
        value: 'csv',
        filename: 'export.csv',
        mimetype: 'text/csv',
    },
    excel: {
        value: 'excel',
        filename: 'export-structured.xlsx',
        mimetype: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
};

const SurveyDownloadButton = ({item, disabled, children, onExport, showEmptyWarning, instanceType, surveyCompleted, surveyStarted, ...rest}) => {
    const [isOpen, setOpen] = React.useState(false);
    const [submitting, setSubmitting] = React.useState(false);
    const toggle = React.useCallback(() => setOpen(!isOpen), [isOpen]);

    const handleSubmit = React.useCallback((values) => {
        setSubmitting(true);
        try {
            const params = {
                format: formats[values.format].filename,
                instanceType: values.instanceType,
            };
            onExport(params);
        } finally {
            setOpen(false);
            setSubmitting(false);
        }
    }, [onExport]);

    const initialValues = {
        format: formats.excel.value,
        instanceType: instanceType || INSTANCE_FILTERS.COMPLETED,
    };

    return (
        disabled || submitting ?
            <a className="disabled">{children}</a> :
            <>
                <a onClick={toggle} {...rest} >{children}</a>
                <SurveyDownloadModal initialValues={initialValues} showEmptyWarning={showEmptyWarning} isOpen={isOpen}
                    surveyCompleted={surveyCompleted} surveyStarted={surveyStarted}
                    toggle={toggle} onSubmit={handleSubmit} submitting={submitting} />
            </>
    );
};

export default SurveyDownloadButton;
